const DiamondDivider = () => (
  <div className="w-full h-10 relative overflow-hidden select-none" aria-hidden="true">
    <div
      className="absolute inset-0"
      style={{
        background: `
          repeating-linear-gradient(
            45deg,
            #4a4a4a 0px,
            #4a4a4a 6px,
            #3a3a3a 6px,
            #3a3a3a 12px
          )
        `,
        boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.6), inset 0 -2px 4px rgba(255,255,255,0.08)',
      }}
    />
    <div
      className="absolute inset-0"
      style={{
        background: `
          repeating-linear-gradient(
            -45deg,
            transparent 0px,
            transparent 6px,
            rgba(0,0,0,0.15) 6px,
            rgba(0,0,0,0.15) 12px
          )
        `,
      }}
    />
    <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#C0C0C0] to-transparent opacity-60" />
    <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#C0C0C0] to-transparent opacity-40" />
  </div>
);

export default DiamondDivider;
